import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoCaseIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 160,
	height: 160,
	viewBox: "0 0 160 160",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M77.7 130.6C105.7 130.6 128.4 107.9 128.4 79.8C128.4 51.7 105.6 29 77.7 29C49.7 29 27 51.7 27 79.8C27 107.9 49.7 130.6 77.7 130.6Z",
			fill: "#F5F6FA"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_dd_12671_34768)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M92.3986 52.8008L107.699 107.801C108.199 109.701 107.099 111.601 105.199 112.101L51.2986 126.401C49.3986 126.901 47.4986 125.801 46.9986 123.901L28.1986 52.9008C27.6986 51.0008 28.7986 49.1008 30.6986 48.6008L69.6986 38.3008L92.3986 52.8008Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M91.5988 87.6012L62.4988 95.3012L59.2988 96.1012L49.5988 98.7012C49.1988 98.8012 48.8988 99.3012 49.0988 99.8012C49.1988 100.301 49.6988 100.601 50.0988 100.501L59.7988 97.9012L62.9988 97.1012L92.0988 89.4012C92.4988 89.3012 92.7988 88.8012 92.5988 88.3012C92.4988 87.8012 91.9988 87.5012 91.5988 87.6012Z",
			fill: "#D5DAE5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.6996 80.8007L78.8996 83.6007L75.1996 84.6007L47.8996 91.9007C47.4996 92.0007 47.1996 92.5007 47.3996 93.0007C47.4996 93.5007 47.9996 93.8007 48.3996 93.7007L75.7996 86.4007L79.4996 85.4007L90.2996 82.6007C90.6996 82.5007 90.9996 82.0007 90.7996 81.5007C90.5996 81.1007 90.0996 80.7007 89.6996 80.8007Z",
			fill: "#D5DAE5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M88.0973 73.9002L85.2973 74.6002L82.4973 75.3002L45.9973 85.0002C45.5973 85.1002 45.2973 85.6002 45.4973 86.1002C45.5973 86.6002 46.0973 86.9002 46.4973 86.8002L82.9973 77.1002L86.0973 76.3002L88.5973 75.6002C88.9973 75.5002 89.2973 75.0002 89.0973 74.5002C88.9973 74.1002 88.5973 73.8002 88.0973 73.9002Z",
			fill: "#D5DAE5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M71.1974 109.302L69.1974 109.802C68.7974 109.902 68.2974 109.602 68.1974 109.102C68.0974 108.602 68.2974 108.102 68.6974 108.002L70.6974 107.502C71.0974 107.402 71.5974 107.702 71.6974 108.202C71.7974 108.802 71.5974 109.202 71.1974 109.302Z",
			fill: "#D5DAE5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.0997 110.901L53.5997 113.901C53.1997 114.001 52.6997 113.701 52.5997 113.201C52.4997 112.701 52.6997 112.201 53.0997 112.101L64.5997 109.101C64.9997 109.001 65.4997 109.301 65.5997 109.801C65.7997 110.301 65.5997 110.801 65.0997 110.901Z",
			fill: "#D5DAE5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.698 66.9999L77.598 69.3999L75.398 69.9999L44.298 78.1999C43.898 78.2999 43.598 78.7999 43.798 79.2999C43.898 79.7999 44.398 80.0999 44.798 79.9999L75.798 71.8999L77.998 71.2999L86.998 68.8999C87.498 68.7999 87.698 68.2999 87.598 67.6999C87.598 67.2999 87.098 66.8999 86.698 66.9999Z",
			fill: "#D5DAE5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.1973 51.9005L39.3973 58.7005C38.7973 58.9005 38.1973 58.5005 37.9973 57.9005C37.7973 57.3005 38.1973 56.7005 38.7973 56.5005L64.5973 49.7005C65.1973 49.5005 65.7973 49.9005 65.9973 50.5005C66.1973 51.1005 65.7973 51.7005 65.1973 51.9005Z",
			fill: "#D5DAE5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.0005 62.3009L41.1005 64.9009C40.5005 65.1009 39.9005 64.7009 39.7005 64.1009C39.5005 63.5009 39.9005 62.9009 40.5005 62.7009L50.3005 60.1009C50.9005 59.9009 51.5005 60.3009 51.7005 60.9009C51.9005 61.5009 51.5005 62.1009 51.0005 62.3009Z",
			fill: "#D5DAE5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M69.6992 38.3008L73.6992 53.5008C74.2992 55.6008 76.5992 56.9008 78.6992 56.3008L92.3992 52.8008",
			fill: "#D5DAE5"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter1_dd_12671_34768)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M132.801 68.2994L123.601 124.699C123.301 126.599 121.401 127.899 119.501 127.499L64.7009 117.899C62.8009 117.599 61.5009 115.699 61.8009 113.799L74.5009 41.4994C74.8009 39.5994 76.7009 38.2994 78.6009 38.6994L118.401 45.6994L132.801 68.2994Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.502 99.5994L87.9022 94.3994L84.7022 93.7994L74.8022 92.0994C74.4022 91.9994 73.9022 92.3994 73.9022 92.8994C73.8022 93.3994 74.1022 93.8994 74.5022 93.9994L84.4022 95.6994L87.6022 96.2994L117.202 101.499C117.602 101.599 118.102 101.199 118.102 100.699C118.202 100.199 118.002 99.6994 117.502 99.5994Z",
			fill: "#D5DAE5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M118.699 92.699L107.699 90.799L103.999 90.099L76.0991 85.199C75.6991 85.099 75.1991 85.499 75.1991 85.999C75.0991 86.499 75.3991 86.999 75.7991 87.099L103.699 91.999L107.399 92.699L118.399 94.599C118.799 94.699 119.299 94.299 119.299 93.799C119.399 93.299 119.099 92.799 118.699 92.699Z",
			fill: "#D5DAE5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M120.099 85.699L117.199 85.199L114.299 84.699L77.0991 78.199C76.6991 78.099 76.1991 78.499 76.1991 78.999C76.0991 79.499 76.3991 79.999 76.7991 80.099L113.999 86.599L117.199 87.199L119.699 87.599C120.099 87.699 120.599 87.299 120.599 86.799C120.799 86.299 120.599 85.799 120.099 85.699Z",
			fill: "#D5DAE5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.9006 110.799L87.9006 110.499C87.5006 110.399 87.2006 109.899 87.3006 109.399C87.4006 108.899 87.8006 108.499 88.2006 108.599L90.2006 108.899C90.6006 108.999 90.9006 109.499 90.8006 109.999C90.7006 110.599 90.3006 110.799 89.9006 110.799Z",
			fill: "#D5DAE5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M83.7999 109.699L72.0998 107.699C71.6998 107.599 71.3999 107.099 71.4999 106.599C71.5999 106.099 71.9999 105.699 72.3999 105.799L84.0998 107.799C84.4998 107.899 84.7999 108.399 84.6999 108.899C84.5999 109.499 84.1999 109.799 83.7999 109.699Z",
			fill: "#D5DAE5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.7 78.8986L112.4 77.2986L110.1 76.8986L78.3999 71.2986C77.9999 71.1986 77.4999 71.5986 77.4999 72.0986C77.3999 72.5986 77.6998 73.0986 78.0998 73.1986L109.8 78.7986L112.1 79.1986L121.3 80.7986C121.8 80.8986 122.2 80.4986 122.3 79.9986C122.4 79.4986 122.1 78.9986 121.7 78.8986Z",
			fill: "#D5DAE5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M108.602 56.2001L82.302 51.6001C81.702 51.5001 81.302 50.9001 81.402 50.3001C81.502 49.7001 82.102 49.3001 82.702 49.4001L109.002 54.0001C109.602 54.1001 110.002 54.7001 109.902 55.3001C109.802 55.8001 109.202 56.3001 108.602 56.2001Z",
			fill: "#D5DAE5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M91.3005 59.5995L81.2005 57.7995C80.6005 57.6995 80.2005 57.0995 80.3005 56.4995C80.4005 55.8995 81.0005 55.4995 81.6005 55.5995L91.6005 57.3995C92.2005 57.4995 92.6005 58.0995 92.5005 58.6995C92.4005 59.2995 91.8005 59.6995 91.3005 59.5995Z",
			fill: "#D5DAE5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M118.301 45.6995L115.601 61.1995C115.201 63.3995 116.801 65.4995 119.001 65.8995L132.801 68.2995",
			fill: "#D5DAE5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M95.1008 119.401C107.417 119.401 117.401 109.417 117.401 97.1008C117.401 84.7848 107.417 74.8008 95.1008 74.8008C82.7848 74.8008 72.8008 84.7848 72.8008 97.1008C72.8008 109.417 82.7848 119.401 95.1008 119.401Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.0008 100.7C92.9008 100.3 92.9008 99.9004 92.9008 99.4004C92.9008 97.7004 93.6008 96.2004 95.4008 94.9004L96.9008 93.8004C97.8008 93.1004 98.2008 92.3004 98.2008 91.3004C98.2008 89.9004 97.2008 88.5004 95.1008 88.5004C92.9008 88.5004 91.9008 90.3004 91.9008 92.0004C91.9008 92.4004 91.9008 92.7004 92.0008 93.0004L88.0008 92.9004C87.9008 92.5004 87.8008 92.0004 87.8008 91.5004C87.8008 88.1004 90.3008 84.9004 95.0008 84.9004C99.8008 84.9004 102.401 88.0004 102.401 91.1004C102.401 93.6004 101.101 95.3004 99.3008 96.6004L98.0008 97.5004C96.9008 98.3004 96.3008 99.3004 96.3008 100.5V100.7H93.0008ZM94.7008 102.7C96.1008 102.7 97.2008 103.8 97.2008 105.2C97.2008 106.6 96.1008 107.7 94.7008 107.7C93.3008 107.7 92.2008 106.6 92.2008 105.2C92.3008 103.9 93.3008 102.7 94.7008 102.7Z",
			fill: "#989FB0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M128.481 131.724C127.615 131.724 126.75 131.378 126.057 130.598L111.602 116.143L111.083 116.489C106.409 119.952 100.955 121.769 95.4155 121.769C88.7505 121.769 82.0854 119.086 77.1516 114.412C71.958 109.478 69.1016 102.813 69.1016 95.5421C69.1016 81.0867 80.8736 69.3147 95.329 69.3147C105.197 69.3147 113.853 74.5082 118.527 83.3373C123.114 92.0797 122.508 102.294 116.882 110.517L116.536 111.036L131.078 125.578C132.549 127.05 132.203 128.521 131.943 129.3C131.251 130.685 129.866 131.724 128.481 131.724ZM95.329 76.4991C84.7688 76.4991 76.286 85.0684 76.286 95.5421C76.286 107.487 86.0671 114.672 95.5886 114.672C101.388 114.672 106.668 112.075 110.39 107.401C114.978 101.688 115.757 93.984 112.554 87.319C109.265 80.6539 102.686 76.4991 95.329 76.4991Z",
			fill: "#989FB0"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_dd_12671_34768",
			x: 19.0781,
			y: 33.3008,
			width: 97.7422,
			height: 106.22,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.5 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.15 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_12671_34768"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .5 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_dropShadow_12671_34768",
					result: "effect2_dropShadow_12671_34768"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect2_dropShadow_12671_34768",
					result: "shape"
				})
			]
		}), /* @__PURE__ */ _jsxs("filter", {
			id: "filter1_dd_12671_34768",
			x: 52.7578,
			y: 33.627,
			width: 89.043,
			height: 106.945,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.5 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.15 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_12671_34768"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .5 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_dropShadow_12671_34768",
					result: "effect2_dropShadow_12671_34768"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect2_dropShadow_12671_34768",
					result: "shape"
				})
			]
		})] })
	]
});
export default SvgNoCaseIcon;
